import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 22 21",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 21\" id=\"icon-plus\"><path d=\"M13.87 20.32v-6.96h7.16V7.8h-7.16v-7h-6v7H.71v5.56h7.16v6.96h6Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol